import { useTracking } from 'react-tracking';
import { Text } from '@simplywallst/ui-core';
import { ReviewedByWrapper } from './styled';
import type { Author } from '../hooks/useArticle/types';

interface Props {
  authors?: Author[];
}
const ReviewedByList = ({ authors }: Props) => {
  const { trackEvent } = useTracking();

  if (!authors?.length) {
    return null;
  }
  return (
    <ReviewedByWrapper>
      <Text as="p" opacity={0.7} color="spaceGrayRGBA" typography="xSmall">
        Reviewed by{' '}
        {authors.map((author, index) => (
          <a
            key={index}
            href={`https://simplywall.st/news/about-simply-wall-st-news/${author.slug}`}
            target="_blank"
            onClick={() => {
              trackEvent({
                type: 'track',
                subject: 'reviewed_by',
                action: 'click',
                slug: author.slug,
              });
            }}
            rel="noreferrer"
          >
            {author.name}
            {index === authors.length - 1 ? '' : ', '}
          </a>
        ))}
      </Text>
    </ReviewedByWrapper>
  );
};

export default ReviewedByList;
